enum OwnerType {
    Individual,
    Trust,
    Business,
    GovBLM,
    GovRAL,
    GovSTATE,
    JointTenant,
}

export default OwnerType;



// WEBPACK FOOTER //
// ./src/components/project/sections/TractComponents/OwnerType.ts